import React, { useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import List from "../../components/List";
import { Button, Input, MenuSelect } from "../../components/Form";
import { MdAdd } from "react-icons/md";
import Modal from "../../components/Modals/Modal";
import { FaSave } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";

function SchedulingTemplates() {
	const [modal, setModal] = useState(false);
	const [modal2, setModal2] = useState(-1);
	const [data, setData] = useState([{ task: "", technician: 0 }]);
	const [dropdown1, setDropdown1] = useState(false);
	const [dropdown2, setDropdown2] = useState(false);

	const list = [
		{ name: "Task Name", rates: "100.00 BAM", onClick: () => setModal(true) },
		{ name: "Task Name", rates: "100.00 BAM", onClick: () => setModal(true) },
		{ name: "Task Name", rates: "100.00 BAM", onClick: () => setModal(true) }
		// Add more tasks here
	];

	const dropdownData = [
		{ title: "Task 1" },
		{ title: "Task 2" },
		{ title: "Task 3" }
		// Add more dropdown data here
	];


	const DynamicList = ({ data }) => {
		return (
			<>
				{data.map((item, index) => (
					<div className="flex flex-1 w-full">
						<MenuSelect
							className={"flex justify-between my-2 mx-1"}
							onClick={(e) =>
								setData((state) => {
									let temp = state;
									temp[index].task = e.title;
									return temp;
								})
							}
							datas={dropdownData}
							isMenuOpen={dropdown1 === index}
							setIsMenuOpen={(e) => setDropdown1(e ? index : -1)}
							staticMode>
							<div className="flex justify-between" onClick={() => setDropdown1(index)}>
								{item.task !== "" ? item.task : "Select the task"}
								<BiChevronDown className="text-xl" />
							</div>
						</MenuSelect>
						<MenuSelect
							className={"flex justify-between my-2 mx-1"}
							onClick={(e) =>
								setData((state) => {
									let temp = state;
									temp[index].technician = e.title;
									return temp;
								})
							}
							datas={dropdownData}
							isMenuOpen={dropdown2 === index}
							setIsMenuOpen={(e) => setDropdown2(e ? index : -1)}
							staticMode>
							<div className="flex justify-between" onClick={() => setDropdown2(index)}>
								{item.technician !== "" ? item.technician : "Select the technician"}
								<BiChevronDown className="text-xl" />
							</div>
						</MenuSelect>
					</div>
				))}
			</>
		);
	};

	return (
		<Layout>
			<Container className={"flex flex-1 flex-col divide-y rounded-xl "}>
				<List list={list} click={(e, index) => setModal2(index)} />
			</Container>
			<div className="flex justify-center items-center my-2">
				<Button
					className={"w-52 max-w-fit px-5"}
					onClick={() => setModal(true)}
					label={"Add New Schedule Template"}
					Icon={() => <MdAdd size={22} />}
				/>
			</div>
			<Modal title={modal2 > -1 ? "Edit Schduling template" : "Add Schduling template"} isOpen={modal || modal2 > -1} closeModal={() => {setModal(false); setModal2(-1);}}>
				<div className="flex flex-col items-center">
					<Input label={"Name"} placeholder={"Template Name"} color={true} />
					<DynamicList data={data} />
					<div className="flex flex-1 w-full"></div>
					<Button
						className={
							"my-4 max-w-fit disabled:pointer-events-none hover:none disabled:bg-subMain/50"
						}
						label={"Add Task"}
						Icon={FaSave}
						onClick={() => setData([...data, { task: "", technician: "" }])}
					/>
					<Button label={"Save"} Icon={FaSave} />
				</div>
			</Modal>
		</Layout>
	);
}

export default SchedulingTemplates;
